var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui button",on:{"click":_vm.nocache}},[_vm._v("reload")]),_vm._v(" "),_c('div',{staticClass:"ui button",on:{"click":_vm.clear}},[_vm._v("clear LocalStorage")])])}
var staticRenderFns = []

export { render, staticRenderFns }